var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: "批量添加拼团商品",
          backUrl: "/marketing/groupBuy/groupGoods",
        },
      }),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.fullscreenLoading,
              expression: "fullscreenLoading",
            },
          ],
          staticClass: "box-card mt14",
        },
        [
          _c(
            "el-form",
            {
              ref: "baseForm",
              staticClass: "mt20",
              attrs: {
                model: _vm.baseForm,
                rules: _vm.baseRules,
                "label-width": "170px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "活动日期：", prop: "timeVal" } },
                [
                  _c("el-date-picker", {
                    staticClass: "selWidth",
                    attrs: {
                      type: "daterange",
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd",
                      "picker-options": _vm.pickerOptions,
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                    },
                    model: {
                      value: _vm.baseForm.timeVal,
                      callback: function ($$v) {
                        _vm.$set(_vm.baseForm, "timeVal", $$v)
                      },
                      expression: "baseForm.timeVal",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "拼团时效(单位 小时)：",
                    prop: "effectiveTime",
                  },
                },
                [
                  _c("el-input-number", {
                    staticClass: "selWidth",
                    attrs: {
                      "controls-position": "right",
                      step: 1,
                      "step-strictly": "",
                      min: 1,
                    },
                    model: {
                      value: _vm.baseForm.effectiveTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.baseForm, "effectiveTime", $$v)
                      },
                      expression: "baseForm.effectiveTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "拼团人数：", prop: "people" } },
                [
                  _c("el-input-number", {
                    staticClass: "selWidth",
                    attrs: {
                      "controls-position": "right",
                      step: 1,
                      "step-strictly": "",
                      min: 2,
                    },
                    model: {
                      value: _vm.baseForm.people,
                      callback: function ($$v) {
                        _vm.$set(_vm.baseForm, "people", $$v)
                      },
                      expression: "baseForm.people",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "购买数量限制：", prop: "num" } },
                [
                  _c("el-input-number", {
                    staticClass: "selWidth",
                    attrs: {
                      "controls-position": "right",
                      step: 1,
                      "step-strictly": "",
                      min: 1,
                    },
                    model: {
                      value: _vm.baseForm.num,
                      callback: function ($$v) {
                        _vm.$set(_vm.baseForm, "num", $$v)
                      },
                      expression: "baseForm.num",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "单次购买数量限制：", prop: "onceNum" } },
                [
                  _c("el-input-number", {
                    staticClass: "selWidth",
                    attrs: {
                      "controls-position": "right",
                      step: 1,
                      "step-strictly": "",
                      min: 1,
                    },
                    model: {
                      value: _vm.baseForm.onceNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.baseForm, "onceNum", $$v)
                      },
                      expression: "baseForm.onceNum",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "补齐人数：", prop: "virtualRation" } },
                [
                  _c("el-input-number", {
                    staticClass: "selWidth",
                    attrs: {
                      "controls-position": "right",
                      step: 1,
                      "step-strictly": "",
                      min: 0,
                      max: _vm.baseForm.people - 1,
                    },
                    model: {
                      value: _vm.baseForm.virtualRation,
                      callback: function ($$v) {
                        _vm.$set(_vm.baseForm, "virtualRation", $$v)
                      },
                      expression: "baseForm.virtualRation",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "运费模板：", prop: "tempId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidth",
                      attrs: { placeholder: "请选择运费模板" },
                      model: {
                        value: _vm.baseForm.tempId,
                        callback: function ($$v) {
                          _vm.$set(_vm.baseForm, "tempId", $$v)
                        },
                        expression: "baseForm.tempId",
                      },
                    },
                    _vm._l(_vm.shippingList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动状态：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.baseForm.isShow,
                        callback: function ($$v) {
                          _vm.$set(_vm.baseForm, "isShow", $$v)
                        },
                        expression: "baseForm.isShow",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("关闭"),
                      ]),
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("开启"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "选择商品：" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.addGoods },
                    },
                    [_vm._v("选择商品")]
                  ),
                  _c("span", { staticClass: "ml10 tip" }, [
                    _vm._v(
                      "已选 " + _vm._s(_vm.productList.length) + " 个商品"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.productList, border: "", size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "商品图", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "demo-image__preview" },
                          [
                            _c("el-image", {
                              staticStyle: { width: "40px", height: "40px" },
                              attrs: {
                                src: scope.row.image,
                                "preview-src-list": [scope.row.image],
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  label: "商品名称",
                  "min-width": "220",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "规格", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(scope.row.specType ? "多规格" : "单规格")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "拼团价", "min-width": "170" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input-number", {
                          staticClass: "priceBox",
                          attrs: {
                            "controls-position": "right",
                            size: "small",
                            min: 0,
                            precision: 2,
                            step: 0.1,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.applyPrice(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.batchPrice,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "batchPrice", $$v)
                            },
                            expression: "scope.row.batchPrice",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "限制数量", "min-width": "170" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input-number", {
                          staticClass: "priceBox",
                          attrs: {
                            "controls-position": "right",
                            size: "small",
                            min: 0,
                            step: 1,
                            "step-strictly": "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.applyQuota(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.batchQuota,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "batchQuota", $$v)
                            },
                            expression: "scope.row.batchQuota",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "160", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.editRow(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.removeProduct(scope.$index)
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mt20" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.push("/marketing/groupBuy/groupGoods")
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["admin:combination:save"],
                      expression: "['admin:combination:save']",
                    },
                  ],
                  attrs: {
                    loading: _vm.loading,
                    type: "primary",
                    size: "small",
                  },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("批量提交")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑商品",
            visible: _vm.editVisible,
            width: "900px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.editVisible = $event
            },
          },
        },
        [
          _vm.editProduct
            ? _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.editTab,
                    callback: function ($$v) {
                      _vm.editTab = $$v
                    },
                    expression: "editTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "基础信息", name: "base" } },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "editForm",
                          attrs: {
                            model: _vm.editProduct,
                            rules: _vm.editRules,
                            "label-width": "100px",
                          },
                          nativeOn: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品主图：", prop: "image" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "upLoadPicBox",
                                  on: {
                                    click: function ($event) {
                                      return _vm.modalPicTap(
                                        _vm.editProduct,
                                        "main"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.editProduct.image
                                    ? _c("div", { staticClass: "pictrue" }, [
                                        _c("img", {
                                          attrs: { src: _vm.editProduct.image },
                                        }),
                                      ])
                                    : _c("div", { staticClass: "upLoad" }, [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-camera cameraIconfont",
                                        }),
                                      ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "商品轮播图：", prop: "imagess" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "acea-row" },
                                [
                                  _vm._l(
                                    _vm.editProduct.imagess,
                                    function (img, i) {
                                      return _c(
                                        "div",
                                        { key: i, staticClass: "pictrue" },
                                        [
                                          img.split(".").pop() !== "mp4"
                                            ? _c("img", { attrs: { src: img } })
                                            : _c("video", {
                                                attrs: { src: img },
                                              }),
                                          _c("i", {
                                            staticClass: "el-icon-error btndel",
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeSlider(
                                                  _vm.editProduct,
                                                  i
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm.editProduct.imagess.length < 10
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "upLoadPicBox",
                                          on: {
                                            click: function ($event) {
                                              return _vm.modalPicTap(
                                                _vm.editProduct,
                                                "slider"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("div", { staticClass: "upLoad" }, [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-camera cameraIconfont",
                                            }),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "拼团名称：", prop: "title" } },
                            [
                              _c("el-input", {
                                staticClass: "proInput",
                                attrs: {
                                  maxlength: "249",
                                  placeholder: "请输入拼团名称",
                                },
                                model: {
                                  value: _vm.editProduct.title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editProduct, "title", $$v)
                                  },
                                  expression: "editProduct.title",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "单位：", prop: "unitName" } },
                            [
                              _c("el-input", {
                                staticClass: "proInputSm",
                                attrs: { placeholder: "请输入单位" },
                                model: {
                                  value: _vm.editProduct.unitName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editProduct, "unitName", $$v)
                                  },
                                  expression: "editProduct.unitName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "labeltop",
                              attrs: { label: "商品属性：", required: "" },
                            },
                            [
                              _c(
                                "el-table",
                                {
                                  staticClass: "skuTable",
                                  attrs: {
                                    data: _vm.editProduct.skuList,
                                    size: "mini",
                                    border: "",
                                  },
                                },
                                [
                                  _vm.editProduct.specType
                                    ? _c("el-table-column", {
                                        attrs: {
                                          label: "选中",
                                          width: "55",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (sku) {
                                                return [
                                                  _c("el-checkbox", {
                                                    model: {
                                                      value: sku.row.checked,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          sku.row,
                                                          "checked",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "sku.row.checked",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3168588683
                                        ),
                                      })
                                    : _vm._e(),
                                  _vm._l(
                                    _vm.editProduct.specAttrs,
                                    function (name, i) {
                                      return _c("el-table-column", {
                                        key: "spec" + i,
                                        attrs: {
                                          label: name,
                                          "min-width": "90",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (sku) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(sku.row[name])
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    }
                                  ),
                                  _c("el-table-column", {
                                    attrs: { label: "图片", "min-width": "80" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (sku) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "upLoadPicBox",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.modalPicTap(
                                                        sku.row,
                                                        "sku"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  sku.row.image
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "pictrue tabPic",
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src: sku.row
                                                                .image,
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "upLoad tabPic",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-camera cameraIconfont",
                                                          }),
                                                        ]
                                                      ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1397049621
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "拼团价",
                                      "min-width": "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (sku) {
                                            return [
                                              _c("el-input-number", {
                                                staticClass: "priceBox",
                                                attrs: {
                                                  "controls-position": "right",
                                                  size: "small",
                                                  min: 0,
                                                  precision: 2,
                                                  step: 0.1,
                                                },
                                                model: {
                                                  value: sku.row.price,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      sku.row,
                                                      "price",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "sku.row.price",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3685758273
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "成本价",
                                      "min-width": "80",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (sku) {
                                            return [
                                              _c("span", [
                                                _vm._v(_vm._s(sku.row.cost)),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2359997613
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "原价", "min-width": "80" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (sku) {
                                            return [
                                              _c("span", [
                                                _vm._v(_vm._s(sku.row.otPrice)),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      981728848
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "库存", "min-width": "80" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (sku) {
                                            return [
                                              _c("span", [
                                                _vm._v(_vm._s(sku.row.stock)),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3051640166
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "限量",
                                      "min-width": "150",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (sku) {
                                            return [
                                              _c("el-input-number", {
                                                staticClass: "priceBox",
                                                attrs: {
                                                  "controls-position": "right",
                                                  size: "small",
                                                  type: "number",
                                                  min: sku.row.stock ? 1 : 0,
                                                  max: sku.row.stock,
                                                  step: 1,
                                                  "step-strictly": "",
                                                },
                                                model: {
                                                  value: sku.row.quota,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      sku.row,
                                                      "quota",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "sku.row.quota",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3459710898
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品编号",
                                      "min-width": "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (sku) {
                                            return [
                                              _c("span", [
                                                _vm._v(_vm._s(sku.row.barCode)),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3329582074
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "重量（KG）",
                                      "min-width": "90",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (sku) {
                                            return [
                                              _c("span", [
                                                _vm._v(_vm._s(sku.row.weight)),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2263047526
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "体积(m³)",
                                      "min-width": "90",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (sku) {
                                            return [
                                              _c("span", [
                                                _vm._v(_vm._s(sku.row.volume)),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3538979598
                                    ),
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "商品详情", name: "content" } },
                    [
                      _c("Tinymce", {
                        key: _vm.editProduct.productId,
                        model: {
                          value: _vm.editProduct.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.editProduct, "content", $$v)
                          },
                          expression: "editProduct.content",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmEdit } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }